import { render } from "./NavSelectWithIcon.vue?vue&type=template&id=6dd5b57c&scoped=true"
import script from "./NavSelectWithIcon.vue?vue&type=script&lang=js"
export * from "./NavSelectWithIcon.vue?vue&type=script&lang=js"

import "./NavSelectWithIcon.vue?vue&type=style&index=0&id=6dd5b57c&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd5b57c"]])

export default __exports__